module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/battle-payments-elite.05d31388.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/battle-payments-elite.png
// module id = 3711
// module chunks = 11